import { UserRole } from '@/const/UserRole'
import { Vue } from 'vue-property-decorator'

/**
 * 更新内容の型
 */
export type UpdateCookieValue = {
  /** ニックネーム */
  nickname?: string
  /** アイコンコード */
  avatarIconCode?: string
}

/**
 * 各権限毎のクッキー情報更新ラッパーメソッド
 */
export default class UpdateCookieUtils {
  /**
   * クッキー更新のラッパーメソッド
   *
   * @param role 権限情報
   * @param updateItems 更新内容(複数項目の更新に対応するため配列で受け取る)
   */
  public static async updateCookies(role: string, updateItems: UpdateCookieValue): Promise<void> {
    // 生徒
    if (role === UserRole.STUDENT) {
      await this.updateStudentCookies(updateItems)
    }
    // 先生
    if (role === UserRole.TEACHER || role === UserRole.BRANCH) {
      await this.updateTeacherCookies(updateItems)
    }
    // 塾管理者
    if (role === UserRole.ACADEMY) {
      await this.updateAcademyCookies(updateItems)
    }
    // システム管理者
    if (role === UserRole.ADMIN) {
      await this.updateAdminCookies(updateItems)
    }
  }

  /**
   * 生徒用メソッド
   *
   * @param updateItems 更新情報
   */
  private static async updateStudentCookies(updateItems: UpdateCookieValue): Promise<void> {
    // クッキー取得
    const cookies = Vue.prototype.$appCookies.authStudent.get()

    // ニックネームが指定されていれば更新
    if (updateItems.nickname) {
      cookies['nickname'] = updateItems.nickname
    }

    // アイコンコードが指定されていれば更新
    if (updateItems.avatarIconCode) {
      cookies['avatarIconCode'] = updateItems.avatarIconCode
    }

    // クッキー登録
    await Vue.prototype.$appCookies.authStudent.set(cookies)
  }

  /**
   * 先生用メソッド
   *
   * @param updateItems 更新情報
   */
  private static async updateTeacherCookies(updateItems: UpdateCookieValue): Promise<void> {
    // クッキー取得
    const cookies = Vue.prototype.$appCookies.authTeacher.get()

    // ニックネームが指定されていれば更新
    if (updateItems.nickname) {
      cookies['nickname'] = updateItems.nickname
    }

    // アイコンコードが指定されていれば更新
    if (updateItems.avatarIconCode) {
      cookies['avatarIconCode'] = updateItems.avatarIconCode
    }

    // クッキー登録
    await Vue.prototype.$appCookies.authTeacher.set(cookies)
  }

  /**
   * 塾管理者用メソッド
   *
   * @param updateItems 更新情報
   */
  private static async updateAcademyCookies(updateItems: UpdateCookieValue): Promise<void> {
    // クッキー取得
    const cookies = Vue.prototype.$appCookies.authAcademy.get()

    // ニックネームが指定されていれば更新
    if (updateItems.nickname) {
      cookies['nickname'] = updateItems.nickname
    }

    // アイコンコードが指定されていれば更新
    if (updateItems.avatarIconCode) {
      cookies['avatarIconCode'] = updateItems.avatarIconCode
    }

    // クッキー登録
    await Vue.prototype.$appCookies.authAcademy.set(cookies)
  }

  /**
   * システム管理者用メソッド
   *
   * @param updateItems 更新情報
   */
  private static async updateAdminCookies(updateItems: UpdateCookieValue): Promise<void> {
    // クッキー取得
    const cookies = Vue.prototype.$appCookies.authAdmin.get()

    // ニックネームが指定されていれば更新
    if (updateItems.nickname) {
      cookies['nickname'] = updateItems.nickname
    }

    // アイコンコードが指定されていれば更新
    if (updateItems.avatarIconCode) {
      cookies['avatarIconCode'] = updateItems.avatarIconCode
    }

    // クッキー登録
    await Vue.prototype.$appCookies.authAdmin.set(cookies)
  }
}
